module.exports = __webpack_public_path__ + "static/media/LogoHeader.48fc918c.svg";